import { Dict } from '@se/se.ui.html5';
import { KeyImage } from '../../../../services/imaging/common';

// #region Interfaces

export interface ISeSideKeyImagesFeatureState {
    formType: string;
    selectedItems: KeyImage[]; 
    message: string; // Messaggio visulaizzato quando non ci soo items (pe rerrori, zero result o altro)
    keyImages: KeyImage[];
    imagesPerRowInPlaceholder
}

// #endregion

// #region Types

export type SeSideKeyImagesState = Dict<ISeSideKeyImagesFeatureState>;

// #endregion

// #region States

export const seSideKeyImagesInitialState: SeSideKeyImagesState = {
    report: {
        formType: null,
        selectedItems: [],
        message: null,
        keyImages: [],
        imagesPerRowInPlaceholder: 1
    },
};

// #endregion
